'use es6';

import * as ActionTypes from '../actions/ActionTypes';
import { List, fromJS } from 'immutable';
const initialState = fromJS({
  admins: new List()
});
const users = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADMIN_FETCH_RECEIVED:
      return state.set('admins', fromJS(action.payload));
    default:
      return state;
  }
};
export default users;